var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5947 11.2454C21.5947 10.4599 21.524 9.70824 21.3926 8.98547H11.2256V13.1263L17.081 13.1276C16.8435 14.5054 16.0792 15.6798 14.9081 16.4628V19.1494H18.3935C20.4287 17.2785 21.5947 14.5129 21.5947 11.2454Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9087 16.4628C13.9385 17.1128 12.6891 17.493 11.2275 17.493C8.404 17.493 6.00879 15.6033 5.15101 13.056H1.55566V15.8266C3.33691 19.3376 6.99795 21.7468 11.2275 21.7468C14.1507 21.7468 16.6066 20.7919 18.3942 19.1481L14.9087 16.4628Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81292 11.0007C4.81292 10.2855 4.93293 9.59406 5.15148 8.94407V6.17346H1.55614C0.819633 7.62527 0.405273 9.26404 0.405273 11.0007C0.405273 12.7373 0.820896 14.3761 1.55614 15.8279L5.15148 13.0573C4.93293 12.4073 4.81292 11.7159 4.81292 11.0007Z",
    fill: "#FABB05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2275 4.50708C12.823 4.50708 14.2518 5.05292 15.3799 6.1195L18.4687 3.05402C16.5927 1.31862 14.147 0.253296 11.2275 0.253296C6.99921 0.253296 3.33691 2.66252 1.55566 6.17346L5.15101 8.94406C6.00879 6.39681 8.404 4.50708 11.2275 4.50708Z",
    fill: "#E94235"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.6f14273a263f8c5dabae8563d88d5781.svg";
export { ForwardRef as ReactComponent };